const filesModuleConstants = {
  GET_FILE_REQUEST: 'GET_FILE_REQUEST',
  GET_FILE_SUCCESS: 'GET_FILE_SUCCESS',
  GET_FILE_FAILURE: 'GET_FILE_FAILURE',
};

export default filesModuleConstants;
